import React from 'react'
import { Button } from 'shared/ui'
import { DefaultModalActions } from 'shared/ui/Modal/ui/DefaultModal/DefaultModalActions.tsx'

export type IMessageModalActionsProps = {
  onCancel: () => void
  onSave: () => void
  onDelete?: () => void
  disabledSave?: boolean
}

export const MessageModalActions = ({
  onCancel,
  onSave,
  onDelete,
  disabledSave,
}: IMessageModalActionsProps) => {
  return (
    <div onMouseDown={(e) => e.stopPropagation()}>
      <DefaultModalActions>
        {onDelete && (
          <Button
            style={{ marginRight: 'auto' }}
            typeBtn={'contained'}
            text={'Delete action'}
            size={'medium'}
            contained={'secondary'}
            intent={'destructive'}
            onClick={onDelete}
          />
        )}
        <Button
          typeBtn={'contained'}
          text={'Cancel'}
          size={'medium'}
          contained={'secondary'}
          onClick={onCancel}
        />
        <Button
          typeBtn={'contained'}
          text={'Save'}
          size={'medium'}
          contained={'primary'}
          onClick={onSave}
          disabled={disabledSave}
        />
      </DefaultModalActions>
    </div>
  )
}
